class ImageFormElementController {
  constructor() {}

  removeUpload() {
    this.thumb = null;
    this.showUpload = true;
  }

  _remove() {
    this.showUpload = true;
    this.removeFile();
  }

  $onInit() {
    this.showUpload = false;

    this.sizes = {
      header: {
        large_image: {
          width: 960,
          height: 480
        },
        medium_image: {
          width: 640,
          height: 320
        }
      },
      icon: {
        image: {
          width: 75,
          height: 20
        }
      },
      inline: {
        large_image: {
          width: 900,
          height: 228
        },
        medium_image: {
          width: 600,
          height: 152
        }
      },
      pin: {
        image: {
          width: 105,
          height: 153,
          format: 'PNG'
        }
      },
      small: {
        image: {
          width: 105,
          height: 153
        }
      },
      social: {
        large_image: {
          width: 900,
          height: 0
        },
        medium_image: {
          width: 600,
          height: 0
        }
      },
      location: {
        large_image: {
          width: 960,
          height: 480
        },
        medium_image: {
          width: 640,
          height: 320
        }
      },
      home_location_filter: {
        image: {
          width: 400,
          height: 400
        }
      },
      experience: {
        image: {
          width: 400,
          height: 400
        }
      },
      dynamic_link: {
        image: {
          width: 72,
          height: 72,
          format: 'PNG'
        }
      }
    };

    this.imageWidth =
      this.sizes[this.type].large_image !== undefined
        ? this.sizes[this.type].large_image.width
        : this.sizes[this.type].image.width;
    this.imageHeight =
      this.sizes[this.type].large_image !== undefined
        ? this.sizes[this.type].large_image.height
        : this.sizes[this.type].image.height;
    this.format = this.sizes[this.type].image !== undefined && this.sizes[this.type].image.format !== undefined
      ? this.sizes[this.type].image.format
      : 'JPG or PNG';
  }
}

export default ImageFormElementController;
